/* global BRAND */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { LanguageService } from 'loankeeper-common/helpers/language'


import { ThunkApi } from '../index.d'

const languages = process.env.LANG_LOCALES as unknown as string[]


function registerTranslations(messages) {
  function buildFormMessages(form, messages = {}) {
    return Object.keys(messages).reduce((accumulator, key) => {
      accumulator[`${form}-${key}`] = messages[key] // eslint-disable-line
      return accumulator
    }, {})
  }

  Object.keys(messages).forEach((formName) => {
    //generating languages files based on env(set from env.js), new way
    const langs = {};
    languages.forEach(lang => {
      langs[lang] = buildFormMessages(formName, messages[formName][lang])
    })
    //end of generating

    //generating laguages statically, old way
    // const eng = buildFormMessages(formName, messages[formName].eng)
    // const geo = buildFormMessages(formName, messages[formName].geo)
    // const rus = buildFormMessages(formName, messages[formName].rus)
    // const aze = buildFormMessages(formName, messages[formName].aze)
    //end of generating

    // LanguageService.registerStatic(formName, { eng, geo, rus, aze })
    LanguageService.registerStatic(formName, langs)
  })
}

// export const loadTranslations = createAsyncThunk<void, void, ThunkApi>(
//   '[TRANSLATIONS] LOAD_TRANSLATIONS',
//   async (_, { extra, rejectWithValue }) => {
//     const result = await extra.api.translations.get()

//     if (result.success) {
//       registerTranslations(result.data)
//       return
//     }

//     return rejectWithValue('Failed to load translations')
//   }
// )

// temporary
export const loadTranslations = createAsyncThunk<void, void, ThunkApi>('[TRANSLATIONS] LOAD_TRANSLATIONS', async () => {
  const messages = await require('../../translations.json')
  registerTranslations(messages)
})
